// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","form":"styles_form__L3gBU","submit":"styles_submit__Fw1hb"};